import { useGlobalStore } from '../global-store';

/**
 * Hook to access store initialization status.
 *
 * Intentionally kept in its own file (separate from store-provider.tsx)
 * to avoid a circular dependency:
 * store-provider → @/components/Auth → @/store → store-provider
 *
 * Because this hook only depends on global-store (not on store-provider),
 * placing it here ensures a clean, acyclic import graph.
 */
export const useStoreInitialization = () => {
  // Select minimum state needed by consumers to avoid over-subscribing.
  const isLoading = useGlobalStore((state) => state.isLoading);
  const error = useGlobalStore((state) => state.error);
  const usageConsentAccepted = useGlobalStore((state) => state.usageConsentAccepted);

  return { isLoading, error, usageConsentAccepted };
};
